import type BaseModel from "../../models/BaseModel";
import { ApplicationMode } from "../../models/SettingsEnums";

let revealTimer: ReturnType<typeof setTimeout> | undefined;

/** Follow keyboard focus only after it has rested on the same row for 300 ms. */
export function scheduleC1NavigatorReveal(object: BaseModel, row: HTMLElement): void {
  if (revealTimer !== undefined) clearTimeout(revealTimer);
  revealTimer = setTimeout(() => {
    revealTimer = undefined;
    if (document.activeElement !== row || !row.isConnected || object.isDeleted ||
      state.selectionManager.selectedObject !== object) return;
    state.c1?.revealNavigatorObject?.(object);
  }, 300);
}

/** Keyboard activation and double-click use the same plan-owned zoom action for C1 objects. */
export function zoomC1NavigatorObject(object: BaseModel): boolean {
  if (state.settings.applicationMode !== ApplicationMode.ConceptOne ||
    !["Room", "Group", "Consumer", "Button"].includes(object.className)) return false;
  return Boolean(state.c1?.zoomNavigatorObject?.(object));
}
